import { Deserializable } from "./deserializable.interface";

export default class Model{
    fromJson(input: {}) {
        Object.assign(this, input);
    }
}